import { connect } from 'react-redux';
import { find } from 'lodash';
import { injectIntl } from 'react-intl';
import { compose } from 'recompose';

import { MODAL_UPDATE_UPLOAD_FILE } from 'modules/messageSystem/constants/modalCodes';
import { getFileNameWithoutExtension, getFileNameWithMaxLenght } from 'modules/messageSystem/utils/fileUpload';
import { withEscHandler } from 'shared/hocs/modalWithEscHandler';

import ModalUpdateUploadFile from './ModalUpdateUploadFile';

const onModalDismiss = state => filename => {
  const uploadModal = find(state.messageSystem.modals.queue, ({ typeId }) => typeId === MODAL_UPDATE_UPLOAD_FILE);
  if (uploadModal) {
    uploadModal.bodyValues.fileName = filename;
  }
};

function mapStateToProps(state, ownProps) {
  const maxLength = 50;
  const { bodyValues: { fileName, file } } = ownProps;
  const localFileUrl = URL.createObjectURL(file);

  return {
    onModalDismiss: onModalDismiss(state),
    fileName: getFileNameWithMaxLenght(getFileNameWithoutExtension(fileName), maxLength),
    fileType: file.type,
    maxLength,
    localFileUrl,
  };
}

export default compose(
  connect(
    mapStateToProps,
    null,
    null,
    {
      areStatesEqual: (next, prev) => prev.messageSystem.modals.currentModal === next.messageSystem.modals.currentModal,
    }),
  withEscHandler,
  injectIntl,
)(ModalUpdateUploadFile);
